import React from "react";
import ApiButton from "../../../../shared/ui/Api.Button";
import { applicationConnector } from "../../../../services/applications/connector";
import moment from "moment";

const AutoReview = ({ application, createKreditzReview }) => {
  return (
    <React.Fragment>
      {application.AutoReviews.map((item) => {
        return (
          <div key={item.Id}>
            <strong>
              {item.Type} : {item.Result} (
              {moment(new Date(item.Created)).format("YYYY-MM-DD HH:mm:ss")})
            </strong>
            {item.Type == "Kreditz" && (
              <a
                href={"/newLoans/kreditz/" + item.Id}
                rel="noreferrer"
                target={"_blank"}
              >
                &nbsp;Details
              </a>
            )}

            <ReasoningRender reasoning={item.Reasoning} />
          </div>
        );
      })}
      <ApiButton
        sending={application.createKreditzReviewPending}
        error={application.kreditzError}
        buttonLabel={"New Kreditz review"}
        onButtonClick={() => createKreditzReview(application.Id)}
      />
    </React.Fragment>
  );
};

const PlaceBreakIfNotLastElement = (index, size) => {
  if (index === size) return undefined;
  return <br />;
};

const ReasoningRender = ({ reasoning }) => {
  let lines = reasoning.toString().split(/\r?\n/);
  return (
    <div>
      {lines.map((item, index) => (
        <span
          key={item}
          style={checkForReject(item) ? { color: "red" } : undefined}
        >
          {item}
          <PlaceBreakIfNotLastElement index={index} size={lines.length} />
        </span>
      ))}
    </div>
  );

  function checkForReject(itemToCheck) {
    return itemToCheck.includes("failed!") || itemToCheck.includes("Reject!");
  }
};

export default applicationConnector(AutoReview);
